<template>
  <div>
    <disclamer-modal></disclamer-modal>

    <actions-modal :selected-shops="selectedShops" :selected-shops-part="selectedShopsPart"></actions-modal>

    <div class="panel">
      <div class="panel-heading">
        <div class="panel-label">
          <h3 slot="header">Shops</h3>
        </div>

        <div class="searchAll">
          <p>Show also disabled shops</p>
          <vue-checkbox-toggle
            ref="checkbox"
            v-model="searchAll"
            show-labels
            label-checked="on"
            label-unchecked="off"
            id="shops-view-toggle"
          ></vue-checkbox-toggle>
        </div>

        <div class="panel-toolbar">
          <Guard :hideFor="['shop_owner']">
            <router-link
              :to="{ name: $TYPES.ROUTES.REGISTRATION+'shop' }"
              class="btn btn-sm btn-primary"
            >
              Create new shop
              <i class="icon icon-cph_iconset_plus"></i>
            </router-link>
          </Guard>
        </div>

      </div>
      <div class="panel-body">

        <div class="key-account-box">
          <shop-owner-selector
            :currentUser="currentUser"
            @changeUser="userChange"
          ></shop-owner-selector>
        </div>

        <div class="map-box">
          <map-component :shops="currentData"></map-component>
        </div>


      </div>
      <table-vue
      trackBy="name"
      dataPath="results"
      paginationPath="pagination"
      :url="`${apiUrl}/store/`"
      :css="css"
      :paginationSchema="paginationSchema"
      :currentPage="currentPage"
      :fields="fields"
      :querySchema="querySchema"
      :appendParams="appendParams"
      :httpOptions="{
        headers:{
          'x-pck': xPck
        },
        auth: auth
      }"
      :perPage="onPage"
      :useSearch="true"
      @pageData="onPageData"
      @selectedData="onSelectData"
      @perPage="changePerPage"
      @currentPage="changCurrentPage"
      id="show-view--table"
      ></table-vue>
      <Guard :showFor="['admin', 'key_account']">
          <div class="panel-footer">
              <div class="flying-box">
                  <div class="box">
                      <button class="btn btn-success" @click="showDisclamerModal">SELECTED ACTIONS</button>
                  </div>
              </div>
          </div>
      </Guard>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import MapComponent from '../../../components/Panel/Geo/MapComponent.vue';
import KeyAccountPicker from '../../../components/Shared/KeyAccountPicker/KeyAccountPicker';
import VueCheckboxToggle from '../../../components/Shared/Toggler';
import DisclamerModal from '../../../components/Panel/Shops/modals/disclamer';
import ActionsModal from '../../../components/Panel/Shops/modals/actions';
import Table from 'table-vue/src/components/Table.vue';
import TableStyles from '../../../components/Panel/Table/TableStyles';
import Input from "../../../components/Panel/Registration/Shops/SubForms/Envs/Input";

export default {
    name: 'shops',
    components: {
        Input,
        MapComponent: MapComponent,
        ShopOwnerSelector: KeyAccountPicker,
        VueCheckboxToggle,
        DisclamerModal,
        ActionsModal,
        'table-vue': Table
    },
    computed: {
        ...mapGetters({
            auth: 'getAuth',
            fields: 'getFields',
            paginationSchema: 'getPaginationSchema',
            querySchema: 'getQuerySchema',
            onPage: 'getOnPageStore',
            currentPage: 'getCurrentStorePage',
            xPck: 'getXPck',
            apiUrl: 'getApiUrl'
        }),
        appendParams (){
          return { disabled: this.searchAll, userId: this.currentUser && this.currentUser.id };
        },
        css (){
          const table = {...TableStyles.table,
          ascendingIcon: 'bi-chevron-compact-down',
          descendingIcon: 'bi-chevron-compact-up',
          sortableIcon: 'bi-chevron-expand'};
          return table;
        }
    },
    created () {
      this.getAuthFromToken();
      this.searchAll = this.getEitherDisabledShops;
    },
    data () {
        return {
            selectedShops: [],
            selectedShopsPart: {
                online: [],
                offline: []
            },
            currentUser: undefined,
            bulk: false,
            currentData: [],
            searchAll: false,
            showOffline: false,
            selection: []
               };
    },
    methods: {
      ...mapActions([
        'SaveSelectedShops',
        'getAuthFromToken',
        'setOnPageStoreLimit',
        'setCurrentStorePage'
      ]),
      onPageData (data){
        this.currentData = data.results;
      },
      changePerPage (perPage){
        this.setOnPageStoreLimit(perPage);
      },
      changCurrentPage (currentPage){
        this.setCurrentStorePage(currentPage);
      },
      onSelectData (data) {
         this.selectedShops = data;
       },
      userChange: function(data){
        this.currentUser = data;
      },
      showDisclamerModal: function () {
          this.selectedShopsPart = {
              online: [],
              offline: []
          };
          this.selectedShops.forEach(shop => {
              if (shop.online) {
                  this.selectedShopsPart.online.push(shop);
              } else {
                  this.selectedShopsPart.offline.push(shop);
              }
          })
          this.SaveSelectedShops({ list: this.selectedShops });
          this.$modal.show('disclamer');
          this.$nextTick(()=>{
            this.selection.forEach(r => {
              this.$refs.multipleTable.toggleRowSelection(r,true)
            })
        })
      }
    }
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
}
.map-box {
  position: relative;
  border: 1px solid #000;
  z-index: 9;
  margin-bottom: 10px;
  margin-top: 10px;
}
div.searchAll {
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
}
.lamp {
  height: 20px;
  width: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  &.online{
    background-color: green;
  }
  &.paper {
    border-radius: 0;
    background-color: #ddd;

    &.error {
        background-color: red;
    }
    &.low {
        background-color: #eac800;
    }
    &.ok {
        background-color: green;
    }
  }

}

.key-account-box {
  margin-bottom: 1em;
  z-index: 10;
  position: relative;
}
.panel {
  .panel-heading {
    min-height: 24px;
    padding-top: 3px;
    padding-bottom: 3px;
    h5 {
      font-size: 24px;
      margin-bottom: 0;
      line-height: 30px;
    }
  }
  &.panel-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  &.panel-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  &.actions {
    ul {
      list-style-type: none;
      padding-inline-start: 0;
    }
  }
  label {
    display: block;
    float: left;
    line-height: 2em;
    width: 100%;
  }
}

.panel .panel-footer {
  text-align: center;
}
</style>
<style lang="scss" >
@media only screen and (max-width: 770px) {
    #shops-view-toggle {
        .checkbox-label {
            display: none;
        }
    }

    #show-view--table {
        input, select {
            font-size: 1.5vw;
        }

        th, td {
            padding: unset;
            font-size: 1.5vw;
        }

        .action-button-group {
            &--link {
                font-size: 1.5vw;
            }
        }

        select.form-control.selecter {
            font-size: unset;
        }
    }
}

@media only screen and (max-width: 530px) {
    #show-view--table {

        th, td {
            word-wrap: break-word;
            max-width: 1vw;
            font-weight: 500;
        }
    }
}
</style>
